var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showpop,
          expression: "showpop",
        },
      ],
      staticClass: "maskTips",
    },
    [
      _vm.iscopy
        ? _c(
            "div",
            {
              staticStyle: {
                width: "100%",
                height: "100%",
                background: "rgba(0, 0, 0, 0.4)",
              },
            },
            [
              _c("iframe", {
                ref: "mainIframe",
                staticStyle: {
                  width: "100%",
                  height: "100%",
                  "overflow-x": "hidden",
                  border: "0px",
                  "margin-top": "-20px",
                },
                attrs: {
                  src: "./pricing.html",
                  id: "mainIframe",
                  name: "mainIframe",
                },
              }),
            ]
          )
        : _c(
            "div",
            {
              staticStyle: {
                padding: "0px 0px 116px 0",
                "max-width": "1400px",
                "border-radius": "16px",
              },
            },
            [
              _c("div", { staticClass: "maskRights" }, [
                _c("div", { staticClass: "buySuccess" }, [
                  _c("i", { staticClass: "close" }),
                  _c("div", [
                    _c("img", {
                      attrs: {
                        src: require("../assets/success.svg"),
                        alt: "Success",
                      },
                    }),
                    _c("p", { staticClass: "info Member" }, [
                      _vm._v(_vm._s(_vm.$t("return_home"))),
                    ]),
                    _c("p", { staticClass: "info noMember" }, [
                      _vm._v(_vm._s(_vm.$t("congratulations"))),
                      _c("span", { staticClass: "loginMaskbtn" }, [
                        _vm._v(_vm._s(_vm.$t("login_benefits"))),
                      ]),
                      _vm._v(_vm._s(_vm.$t("no_registered"))),
                      _c("span", { staticClass: "registerMaskbtn" }, [
                        _vm._v(_vm._s(_vm.$t("register_account"))),
                      ]),
                      _vm._v(_vm._s(_vm.$t("other_accounts"))),
                    ]),
                    _c("span", { staticClass: "btn" }, [
                      _vm._v(_vm._s(_vm.$t("btn_close"))),
                    ]),
                  ]),
                ]),
              ]),
              _c("i", { staticClass: "close", on: { click: _vm.closePop } }),
              _c("div", { staticClass: "banner" }, [
                _c(
                  "div",
                  { staticClass: "container", staticStyle: { margin: "auto" } },
                  [_c("h1", [_vm._v(_vm._s(_vm.$t("banner_msg")))])]
                ),
              ]),
              _c("div", { staticClass: "tab_nav container" }, [
                _c("ul", [
                  _c("li", { staticClass: "active" }, [
                    _vm._v(_vm._s(_vm.$t("monthly"))),
                  ]),
                  _c("li", [_vm._v(_vm._s(_vm.$t("lifetime")))]),
                ]),
              ]),
              _c("div", { staticClass: "silder_box container" }, [
                _c("div", [
                  _c("p", [_vm._v(_vm._s(_vm.$t("choose_plan")))]),
                  _vm._m(0),
                ]),
              ]),
              _c("div", { staticClass: "buy_box container flex-box" }, [
                _c("div", { staticClass: "free" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("free"))),
                  ]),
                  _c("p", { staticClass: "info" }, [
                    _c("span", { staticClass: "active" }, [
                      _vm._v("2 " + _vm._s(_vm.$t("images"))),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t("pricing.without_watermark"))),
                  ]),
                  _c(
                    "p",
                    { staticClass: "price", staticStyle: { display: "block" } },
                    [
                      !_vm.pricing.place
                        ? _c("sup", [_vm._v(_vm._s(_vm.pricing.symbol))])
                        : _vm._e(),
                      _vm._v("0"),
                      _vm.pricing.place
                        ? _c("sup", [_vm._v(_vm._s(_vm.pricing.symbol))])
                        : _vm._e(),
                    ]
                  ),
                  _c(
                    "a",
                    {
                      staticClass: "btn active unbind",
                      staticStyle: { "margin-top": "48px" },
                      attrs: { href: "/image-upscaler/" },
                    },
                    [_vm._v(_vm._s(_vm.$t("btn_get_started")))]
                  ),
                  _c("dl", [
                    _c("dt", [_vm._v(_vm._s(_vm.$t("access_to")) + ":")]),
                    _c("dd", [
                      _c("i"),
                      _vm._v(_vm._s(_vm.$t("pricing.upload_images")) + " "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("pricing.under")) + " 10MB"),
                      ]),
                    ]),
                    _c("dd", [
                      _c("i"),
                      _vm._v(_vm._s(_vm.$t("pricing.process_images")) + " "),
                      _c("span", [_vm._v("1920×1920")]),
                      _vm._v(" " + _vm._s(_vm.$t("pricing.pixels"))),
                    ]),
                    _c("dd", [
                      _c("i"),
                      _vm._v(_vm._s(_vm.$t("pricing.enjoy_limited"))),
                    ]),
                    _c("dd", [
                      _c("i"),
                      _vm._v(_vm._s(_vm.$t("pricing.download")) + " "),
                      _c("span", [_vm._v("2")]),
                      _vm._v(" " + _vm._s(_vm.$t("pricing.HD_images"))),
                    ]),
                    _c("dd", [
                      _c("i"),
                      _vm._v(_vm._s(_vm.$t("pricing.and_you")) + " "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("pricing.slow_upscaling"))),
                      ]),
                      _vm._v(" & "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("pricing.lower_priority"))),
                      ]),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "monthly active" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("mon"))),
                  ]),
                  _c("p", { staticClass: "info" }, [
                    _c("span", { staticClass: "active" }, [
                      _vm._v("200 " + _vm._s(_vm.$t("buynow.pop.credits"))),
                    ]),
                    _c("span", [
                      _vm._v("500 " + _vm._s(_vm.$t("buynow.pop.credits"))),
                    ]),
                    _c("span", [
                      _vm._v("1000 " + _vm._s(_vm.$t("buynow.pop.credits"))),
                    ]),
                    _c("span", [
                      _vm._v("2000 " + _vm._s(_vm.$t("buynow.pop.credits"))),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t("pricing.without")) + " "),
                  ]),
                  _c("div", [
                    _c(
                      "p",
                      {
                        staticClass: "price active",
                        staticStyle: { "line-height": "14px" },
                      },
                      [
                        !_vm.pricing.place
                          ? _c("sup", [_vm._v(_vm._s(_vm.pricing.symbol))])
                          : _vm._e(),
                        _vm._v(_vm._s(_vm.pricing.monthly_200)),
                        _vm.pricing.place
                          ? _c("sup", [_vm._v(_vm._s(_vm.pricing.symbol))])
                          : _vm._e(),
                        _c("span", { staticClass: "tax" }, [
                          _vm._v("(" + _vm._s(_vm.$t("tax_incl"))),
                          _c("i", [
                            _c("span", { staticClass: "tax_content" }, [
                              _vm._v(_vm._s(_vm.$t("pricing.tax"))),
                            ]),
                          ]),
                          _vm._v(")"),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _c("span", [
                          !_vm.pricing.place
                            ? _c("span", [_vm._v(_vm._s(_vm.pricing.symbol))])
                            : _vm._e(),
                          _vm._v(_vm._s(_vm.pricing.monthly_200_1)),
                          _vm.pricing.place
                            ? _c("span", [
                                _vm._v(" " + _vm._s(_vm.pricing.symbol)),
                              ])
                            : _vm._e(),
                          _vm._v("/" + _vm._s(_vm.$t("buynow.pop.credit"))),
                        ]),
                      ]
                    ),
                    _c(
                      "p",
                      {
                        staticClass: "price",
                        staticStyle: { "line-height": "14px" },
                      },
                      [
                        !_vm.pricing.place
                          ? _c("sup", [_vm._v(_vm._s(_vm.pricing.symbol))])
                          : _vm._e(),
                        _vm._v(_vm._s(_vm.pricing.monthly_500)),
                        _vm.pricing.place
                          ? _c("sup", [_vm._v(_vm._s(_vm.pricing.symbol))])
                          : _vm._e(),
                        _c("span", { staticClass: "tax" }, [
                          _vm._v("(" + _vm._s(_vm.$t("tax_incl"))),
                          _c("i", [
                            _c("span", { staticClass: "tax_content" }, [
                              _vm._v(_vm._s(_vm.$t("pricing.tax"))),
                            ]),
                          ]),
                          _vm._v(")"),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _c("span", [
                          !_vm.pricing.place
                            ? _c("span", [_vm._v(_vm._s(_vm.pricing.symbol))])
                            : _vm._e(),
                          _vm._v(_vm._s(_vm.pricing.monthly_500_1)),
                          _vm.pricing.place
                            ? _c("span", [
                                _vm._v(" " + _vm._s(_vm.pricing.symbol)),
                              ])
                            : _vm._e(),
                          _vm._v("/" + _vm._s(_vm.$t("buynow.pop.credit"))),
                        ]),
                      ]
                    ),
                    _c(
                      "p",
                      {
                        staticClass: "price",
                        staticStyle: { "line-height": "14px" },
                      },
                      [
                        !_vm.pricing.place
                          ? _c("sup", [_vm._v(_vm._s(_vm.pricing.symbol))])
                          : _vm._e(),
                        _vm._v(_vm._s(_vm.pricing.monthly_1000)),
                        _vm.pricing.place
                          ? _c("sup", [_vm._v(_vm._s(_vm.pricing.symbol))])
                          : _vm._e(),
                        _c("span", { staticClass: "tax" }, [
                          _vm._v("(" + _vm._s(_vm.$t("tax_incl"))),
                          _c("i", [
                            _c("span", { staticClass: "tax_content" }, [
                              _vm._v(_vm._s(_vm.$t("pricing.tax"))),
                            ]),
                          ]),
                          _vm._v(")"),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _c("span", [
                          !_vm.pricing.place
                            ? _c("span", [_vm._v(_vm._s(_vm.pricing.symbol))])
                            : _vm._e(),
                          _vm._v(_vm._s(_vm.pricing.monthly_1000_1)),
                          _vm.pricing.place
                            ? _c("span", [
                                _vm._v(" " + _vm._s(_vm.pricing.symbol)),
                              ])
                            : _vm._e(),
                          _vm._v("/" + _vm._s(_vm.$t("buynow.pop.credit"))),
                        ]),
                      ]
                    ),
                    _c(
                      "p",
                      {
                        staticClass: "price",
                        staticStyle: { "line-height": "14px" },
                      },
                      [
                        !_vm.pricing.place
                          ? _c("sup", [_vm._v(_vm._s(_vm.pricing.symbol))])
                          : _vm._e(),
                        _vm._v(_vm._s(_vm.pricing.monthly_2000)),
                        _vm.pricing.place
                          ? _c("sup", [_vm._v(_vm._s(_vm.pricing.symbol))])
                          : _vm._e(),
                        _c("span", { staticClass: "tax" }, [
                          _vm._v("(" + _vm._s(_vm.$t("tax_incl"))),
                          _c("i", [
                            _c("span", { staticClass: "tax_content" }, [
                              _vm._v(_vm._s(_vm.$t("pricing.tax"))),
                            ]),
                          ]),
                          _vm._v(")"),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _c("span", [
                          !_vm.pricing.place
                            ? _c("span", [_vm._v(_vm._s(_vm.pricing.symbol))])
                            : _vm._e(),
                          _vm._v(_vm._s(_vm.pricing.monthly_2000_1)),
                          _vm.pricing.place
                            ? _c("span", [
                                _vm._v(" " + _vm._s(_vm.pricing.symbol)),
                              ])
                            : _vm._e(),
                          _vm._v("/" + _vm._s(_vm.$t("buynow.pop.credit"))),
                        ]),
                      ]
                    ),
                  ]),
                  _c("div", [
                    _c(
                      "a",
                      { staticClass: "btn active", attrs: { plan: "46" } },
                      [_vm._v(_vm._s(_vm.$t("secure_checkout"))), _c("i")]
                    ),
                    _c("a", { staticClass: "btn", attrs: { plan: "47" } }, [
                      _vm._v(_vm._s(_vm.$t("secure_checkout"))),
                      _c("i"),
                    ]),
                    _c("a", { staticClass: "btn", attrs: { plan: "48" } }, [
                      _vm._v(_vm._s(_vm.$t("secure_checkout"))),
                      _c("i"),
                    ]),
                    _c("a", { staticClass: "btn", attrs: { plan: "49" } }, [
                      _vm._v(_vm._s(_vm.$t("secure_checkout"))),
                      _c("i"),
                    ]),
                  ]),
                  _c("dl", [
                    _c("dt", [_vm._v(_vm._s(_vm.$t("pricing.you_can")) + ":")]),
                    _c("dd", [
                      _c("i"),
                      _vm._v(_vm._s(_vm.$t("pricing.up_to")) + " "),
                      _c("span", [_vm._v("50 MB")]),
                    ]),
                    _c("dd", [
                      _c("i"),
                      _vm._v(_vm._s(_vm.$t("pricing.process_images")) + " "),
                      _c("span", [_vm._v("4096×4096")]),
                      _vm._v(" " + _vm._s(_vm.$t("pricing.pixels"))),
                    ]),
                    _c("dd", [
                      _c("i"),
                      _vm._v(_vm._s(_vm.$t("pricing.upscale_images")) + " "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("pricing.no_watermark"))),
                      ]),
                    ]),
                    _c("dd", [
                      _c("i"),
                      _vm._v(
                        _vm._s(_vm.$t("pricing.enhance")) +
                          " 2 " +
                          _vm._s(_vm.$t("pricing.or_more")) +
                          " "
                      ),
                      _c("span", [_vm._v(_vm._s(_vm.$t("pricing.in_batch")))]),
                    ]),
                    _c("dd", [
                      _c("i"),
                      _vm._v(_vm._s(_vm.$t("pricing.enlarge_images")) + " "),
                      _c("span", [
                        _vm._v(
                          "2×, 4×, " + _vm._s(_vm.$t("pricing.and")) + " 8×"
                        ),
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("pricing.times_with"))),
                    ]),
                    _c("dd", [
                      _c("i"),
                      _vm._v(_vm._s(_vm.$t("pricing.enjoy")) + " "),
                      _c("span", [_vm._v("7 " + _vm._s(_vm.$t("days")))]),
                      _vm._v(" " + _vm._s(_vm.$t("pricing.of_history"))),
                    ]),
                    _c("dd", [
                      _c("i"),
                      _vm._v(_vm._s(_vm.$t("pricing.experience")) + " "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("pricing.fast_upscaling"))),
                      ]),
                      _vm._v(" & "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("pricing.higher_priority"))),
                      ]),
                    ]),
                    _c("dd", [
                      _c("i"),
                      _vm._v(_vm._s(_vm.$t("pricing.early_access"))),
                    ]),
                    _c("dd", [
                      _c("i"),
                      _vm._v(_vm._s(_vm.$t("pricing.cancel_anytime"))),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "lifetime" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.$t("left"))),
                  ]),
                  _c("p", { staticClass: "info" }, [
                    _c("span", { staticClass: "active" }, [
                      _vm._v("200 " + _vm._s(_vm.$t("buynow.pop.credits"))),
                    ]),
                    _c("span", [
                      _vm._v("500 " + _vm._s(_vm.$t("buynow.pop.credits"))),
                    ]),
                    _c("span", [
                      _vm._v("1000 " + _vm._s(_vm.$t("buynow.pop.credits"))),
                    ]),
                    _c("span", [
                      _vm._v("2000 " + _vm._s(_vm.$t("buynow.pop.credits"))),
                    ]),
                    _vm._v(" " + _vm._s(_vm.$t("pricing.without")) + " "),
                  ]),
                  _c("div", [
                    _c(
                      "p",
                      {
                        staticClass: "price active",
                        staticStyle: { "line-height": "14px" },
                      },
                      [
                        !_vm.pricing.place
                          ? _c("sup", [_vm._v(_vm._s(_vm.pricing.symbol))])
                          : _vm._e(),
                        _vm._v(_vm._s(_vm.pricing.lifetime_200)),
                        _vm.pricing.place
                          ? _c("sup", [_vm._v(_vm._s(_vm.pricing.symbol))])
                          : _vm._e(),
                        _c("span", { staticClass: "tax" }, [
                          _vm._v("(" + _vm._s(_vm.$t("tax_incl"))),
                          _c("i", [
                            _c("span", { staticClass: "tax_content" }, [
                              _vm._v(_vm._s(_vm.$t("pricing.tax"))),
                            ]),
                          ]),
                          _vm._v(")"),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _c("span", [
                          !_vm.pricing.place
                            ? _c("span", [_vm._v(_vm._s(_vm.pricing.symbol))])
                            : _vm._e(),
                          _vm._v(_vm._s(_vm.pricing.lifetime_200_1)),
                          _vm.pricing.place
                            ? _c("span", [
                                _vm._v(" " + _vm._s(_vm.pricing.symbol)),
                              ])
                            : _vm._e(),
                          _vm._v("/" + _vm._s(_vm.$t("buynow.pop.credit"))),
                        ]),
                      ]
                    ),
                    _c(
                      "p",
                      {
                        staticClass: "price",
                        staticStyle: { "line-height": "14px" },
                      },
                      [
                        !_vm.pricing.place
                          ? _c("sup", [_vm._v(_vm._s(_vm.pricing.symbol))])
                          : _vm._e(),
                        _vm._v(_vm._s(_vm.pricing.lifetime_500)),
                        _vm.pricing.place
                          ? _c("sup", [_vm._v(_vm._s(_vm.pricing.symbol))])
                          : _vm._e(),
                        _c("span", { staticClass: "tax" }, [
                          _vm._v("(" + _vm._s(_vm.$t("tax_incl"))),
                          _c("i", [
                            _c("span", { staticClass: "tax_content" }, [
                              _vm._v(_vm._s(_vm.$t("pricing.tax"))),
                            ]),
                          ]),
                          _vm._v(")"),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _c("span", [
                          !_vm.pricing.place
                            ? _c("span", [_vm._v(_vm._s(_vm.pricing.symbol))])
                            : _vm._e(),
                          _vm._v(_vm._s(_vm.pricing.lifetime_500_1)),
                          _vm.pricing.place
                            ? _c("span", [
                                _vm._v(" " + _vm._s(_vm.pricing.symbol)),
                              ])
                            : _vm._e(),
                          _vm._v("/" + _vm._s(_vm.$t("buynow.pop.credit"))),
                        ]),
                      ]
                    ),
                    _c(
                      "p",
                      {
                        staticClass: "price",
                        staticStyle: { "line-height": "14px" },
                      },
                      [
                        !_vm.pricing.place
                          ? _c("sup", [_vm._v(_vm._s(_vm.pricing.symbol))])
                          : _vm._e(),
                        _vm._v(_vm._s(_vm.pricing.lifetime_1000)),
                        _vm.pricing.place
                          ? _c("sup", [_vm._v(_vm._s(_vm.pricing.symbol))])
                          : _vm._e(),
                        _c("span", { staticClass: "tax" }, [
                          _vm._v("(" + _vm._s(_vm.$t("tax_incl"))),
                          _c("i", [
                            _c("span", { staticClass: "tax_content" }, [
                              _vm._v(_vm._s(_vm.$t("pricing.tax"))),
                            ]),
                          ]),
                          _vm._v(")"),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _c("span", [
                          !_vm.pricing.place
                            ? _c("span", [_vm._v(_vm._s(_vm.pricing.symbol))])
                            : _vm._e(),
                          _vm._v(_vm._s(_vm.pricing.lifetime_1000_1)),
                          _vm.pricing.place
                            ? _c("span", [
                                _vm._v(" " + _vm._s(_vm.pricing.symbol)),
                              ])
                            : _vm._e(),
                          _vm._v("/" + _vm._s(_vm.$t("buynow.pop.credit"))),
                        ]),
                      ]
                    ),
                    _c(
                      "p",
                      {
                        staticClass: "price",
                        staticStyle: { "line-height": "14px" },
                      },
                      [
                        !_vm.pricing.place
                          ? _c("sup", [_vm._v(_vm._s(_vm.pricing.symbol))])
                          : _vm._e(),
                        _vm._v(_vm._s(_vm.pricing.lifetime_2000)),
                        _vm.pricing.place
                          ? _c("sup", [_vm._v(_vm._s(_vm.pricing.symbol))])
                          : _vm._e(),
                        _c("span", { staticClass: "tax" }, [
                          _vm._v("(" + _vm._s(_vm.$t("tax_incl"))),
                          _c("i", [
                            _c("span", { staticClass: "tax_content" }, [
                              _vm._v(_vm._s(_vm.$t("pricing.tax"))),
                            ]),
                          ]),
                          _vm._v(")"),
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _c("span", [
                          !_vm.pricing.place
                            ? _c("span", [_vm._v(_vm._s(_vm.pricing.symbol))])
                            : _vm._e(),
                          _vm._v(_vm._s(_vm.pricing.lifetime_2000_1)),
                          _vm.pricing.place
                            ? _c("span", [
                                _vm._v(" " + _vm._s(_vm.pricing.symbol)),
                              ])
                            : _vm._e(),
                          _vm._v("/" + _vm._s(_vm.$t("buynow.pop.credit"))),
                        ]),
                      ]
                    ),
                  ]),
                  _c("div", [
                    _c(
                      "a",
                      { staticClass: "btn active", attrs: { plan: "50" } },
                      [_vm._v(_vm._s(_vm.$t("secure_checkout"))), _c("i")]
                    ),
                    _c("a", { staticClass: "btn", attrs: { plan: "51" } }, [
                      _vm._v(_vm._s(_vm.$t("secure_checkout"))),
                      _c("i"),
                    ]),
                    _c("a", { staticClass: "btn", attrs: { plan: "52" } }, [
                      _vm._v(_vm._s(_vm.$t("secure_checkout"))),
                      _c("i"),
                    ]),
                    _c("a", { staticClass: "btn", attrs: { plan: "53" } }, [
                      _vm._v(_vm._s(_vm.$t("secure_checkout"))),
                      _c("i"),
                    ]),
                  ]),
                  _c("dl", [
                    _c("dt", [
                      _vm._v(_vm._s(_vm.$t("pricing.lifetime_license")) + ":"),
                    ]),
                    _c("dd", [
                      _c("i"),
                      _vm._v(_vm._s(_vm.$t("pricing.up_to")) + " "),
                      _c("span", [_vm._v("50 MB")]),
                    ]),
                    _c("dd", [
                      _c("i"),
                      _vm._v(_vm._s(_vm.$t("pricing.process_images")) + " "),
                      _c("span", [_vm._v("4096×4096")]),
                      _vm._v(" " + _vm._s(_vm.$t("pricing.pixels"))),
                    ]),
                    _c("dd", [
                      _c("i"),
                      _vm._v(_vm._s(_vm.$t("pricing.upscale_images")) + " "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("pricing.no_watermark"))),
                      ]),
                    ]),
                    _c("dd", [
                      _c("i"),
                      _vm._v(
                        _vm._s(_vm.$t("pricing.enhance")) +
                          " 2 " +
                          _vm._s(_vm.$t("pricing.or_more")) +
                          " "
                      ),
                      _c("span", [_vm._v(_vm._s(_vm.$t("pricing.in_batch")))]),
                    ]),
                    _c("dd", [
                      _c("i"),
                      _vm._v(_vm._s(_vm.$t("pricing.enlarge_images")) + " "),
                      _c("span", [
                        _vm._v(
                          "2×, 4×, " + _vm._s(_vm.$t("pricing.and")) + " 8×"
                        ),
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("pricing.times_with"))),
                    ]),
                    _c("dd", [
                      _c("i"),
                      _vm._v(_vm._s(_vm.$t("pricing.enjoy")) + " "),
                      _c("span", [_vm._v("7 " + _vm._s(_vm.$t("days")))]),
                      _vm._v(" " + _vm._s(_vm.$t("pricing.of_history"))),
                    ]),
                    _c("dd", [
                      _c("i"),
                      _vm._v(_vm._s(_vm.$t("pricing.experience")) + " "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("pricing.fast_upscaling"))),
                      ]),
                      _vm._v(" & "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("pricing.higher_priority"))),
                      ]),
                    ]),
                    _c("dd", [
                      _c("i"),
                      _vm._v(_vm._s(_vm.$t("pricing.early_access"))),
                    ]),
                    _c("dd", [
                      _c("i"),
                      _vm._v(_vm._s(_vm.$t("pricing.and_there")) + " "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("pricing.no_expiration"))),
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("pricing.unless"))),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "silder active" }, [
      _c("div", { staticClass: "num flex-box" }, [
        _c("span", [_vm._v("200")]),
        _c("span", [_vm._v("500")]),
        _c("span", [_vm._v("1000")]),
        _c("span", [_vm._v("2000")]),
      ]),
      _c("div", { staticClass: "bg" }, [_c("i")]),
      _c("div", { staticClass: "btn" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }